import { Steps } from "antd";
import React from "react";
import {
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_FAIL,
  ORDER_STATUS_PENDING,
  ORDER_STATUS_SUCCESS,
  //   PAYMENT_METHOD_COD,
  //   PAYMENT_METHOD_TRANSFER,
  //   PAYMENT_STATUS_REFUNDED,
} from "../../common/constant";
// import {
//   IconPaymentPaid,
//   IconPaymentRefunded,
//   IconPaymentUnpaid,
// } from "../images";
import "./stepOrderStatusStyle.scss";
const StepOrderStatus = (props: any) => {
  const { orderDetail } = props;
  const [currentStep, setCurrentStep] = React.useState(0);
  //   const [paymentMethodStatus, setPaymentMethodStatus] = React.useState(0); // chua thanh toan;

  React.useEffect(() => {
    getCurrentStep();
  }, []);

  const getCurrentStep = () => {
    if (orderDetail.order_status === ORDER_STATUS_CANCELLED) {
      setCurrentStep(0);
    }
    if (orderDetail.order_status === ORDER_STATUS_PENDING) {
      setCurrentStep(1);
    }
    if (orderDetail.order_status === ORDER_STATUS_DELIVERING) {
      setCurrentStep(2);
    }
    if (
      orderDetail.order_status === ORDER_STATUS_SUCCESS ||
      orderDetail.order_status === ORDER_STATUS_FAIL
    ) {
      setCurrentStep(3);
    }
  };

  //   const checkPaymentMethod = () => {
  //     if (
  //       orderDetail.payment_method !== PAYMENT_METHOD_COD &&
  //       orderDetail.payment_method !== PAYMENT_METHOD_TRANSFER
  //     ) {
  //       // let srcImg = IconPaymentUnpaid;
  //       setPaymentMethodStatus(0); //chua thanh toan
  //       let img = <img src={IconPaymentUnpaid} alt="" />;
  //       if (orderDetail.payment_transacion_id) {
  //         switch (orderDetail.payment_transacion_id.status) {
  //           case ORDER_STATUS_SUCCESS:
  //             img = <img src={IconPaymentPaid} alt="" />;
  //             setPaymentMethodStatus(1); // da thanh toan
  //             break;
  //           case PAYMENT_STATUS_REFUNDED:
  //             img = <img src={IconPaymentRefunded} alt="" />;
  //             setPaymentMethodStatus(2); // da hoan tien
  //             break;
  //         }
  //       }
  //       return img;
  //     }
  //     console.log("paymentMethod: ", paymentMethod);
  //     return null;
  //   };

  const checkStatusStep = () => {
    if (
      (currentStep === 0 &&
        orderDetail.order_status === ORDER_STATUS_CANCELLED) ||
      (currentStep === 3 && orderDetail.order_status === ORDER_STATUS_FAIL)
    ) {
      return true;
    }

    return false;
  };

  const customDot = (dot: any, { status, index }: any) => <>{dot}</>;

  return (
    <Steps
      current={currentStep}
      status={checkStatusStep() ? "error" : "process"}
      progressDot={customDot}
      className="order-detail-step-order-status-wrapper">
      <Steps.Step
        title={
          orderDetail.order_status !== ORDER_STATUS_CANCELLED
            ? "Đặt hàng thành công"
            : "Đơn hàng đã hủy"
        }
        description=""
      />
      <Steps.Step title="Đã xác nhận" description="" />
      <Steps.Step title="Đang giao hàng" description="" />
      <Steps.Step
        title={
          orderDetail.order_status !== ORDER_STATUS_FAIL
            ? "Giao hàng thành công"
            : "Giao hàng thất bại"
        }
        description=""
      />
    </Steps>
  );
};

export default StepOrderStatus;
